import { forwardRef, type Ref, type SVGProps } from "react";
const IconInfoOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12" />
    <path d="M18.35 19.89h-.89v-4.63A1.15 1.15 0 0 0 16.21 14h-2.37a1.23 1.23 0 1 0 0 2.45h1.07v3.41h-1.26a1.23 1.23 0 1 0 0 2.45h4.7a1.23 1.23 0 1 0 0-2.45Zm-2.44-7.18a1.53 1.53 0 0 0 0-3.05 1.53 1.53 0 1 0 0 3.05" />
  </svg>
);
const ForwardRef = forwardRef(IconInfoOutlineSVG);
ForwardRef.displayName = "IconInfoOutline";
export { ForwardRef as IconInfoOutline };
